/** @format */

const template = `
<div ng-if="$ctrl.attainment" class="studymodule {{$ctrl.getModuleColorCategory()}}" ng-class="{'dimmed': $ctrl.dimmed}">
  <div class="studymodule-top-row">
    <div class="title-box">
      <span class="studymodule-title">{{ $ctrl.attainment.name | localizedString }}</span>
      <span class="studymodule-code">{{ $ctrl.attainment.code }}</span> </div
    ><!--
     --><div class="extra-items-holder">
      <div class="additional-box toggle-box"> <ng-transclude></ng-transclude> </div
      ><!--
         --><div class="grade-box">
        <sis-icon icon="achievement"></sis-icon>
        <span class="grade-text">{{ $ctrl.grade.abbreviation | localizedString }}</span> </div
      ><!--
         --><div class="credits-box">
        <span class="credit-amount">{{ $ctrl.attainment.credits | range }}</span>

        <span class="credit-abbreviation" translate="CREDITS"></span>
      </div>
    </div>
  </div>
  <div class="studymodule-notification-bar">
    <div class="studymodule-notification" ng-repeat="notification in $ctrl.notifications"
      ><!--
            --><span
        class="studymodule-notification-content"
        translate="{{notification.translation}}"
        translate-value-parent-name="{{notification.values.parentName|localizedString}}"></span
      ><!--
            --><span class="studymodule-notification-header"
        ><sis-icon ng-if="notification.type === 'warning'" icon="alert-fill"></sis-icon
      ></span>
    </div>
    <div
      class="studymodule-notification"
      ng-if="$ctrl.isInvalidSelection($ctrl.attainment) && !$ctrl.hasModuleContentApproval($ctrl.attainment)">
      <span class="studymodule-notification-content"> <span translate="PLAN.INVALID_SELECTIONS.NOTIFICATION"></span> </span
      ><!--
         --><span class="studymodule-notification-header"><sis-icon icon="alert-fill"></sis-icon></span>
    </div>
    <div class="studymodule-notification" ng-if="$ctrl.isInvalidAccordingToModuleContentApproval($ctrl.attainment)">
      <span class="studymodule-notification-content">
        <span translate="PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION"></span> </span
      ><!--
         --><span class="studymodule-notification-header"><sis-icon icon="alert-fill"></sis-icon></span>
    </div>
    <div class="studymodule-notification" ng-if="$ctrl.isAboutToExpire($ctrl.attainment)">
      <span class="studymodule-notification-content">
        <span translate="PLAN.MODULE.EXPIRATION_IMMINENT"></span>
        {{$ctrl.attainment.expiryDate | localDateFormat}}. </span
      ><span class="studymodule-notification-header"><sis-icon icon="alert-fill"></sis-icon></span>
    </div>
  </div>
</div>
<div ng-if="!$ctrl.attainment" class="studymodule attainment-data-not-found">
  <div class="studymodule-top-row">
    <div class="title-box">
      <span class="studymodule-title">
        <span translate="SIS_COMPONENTS.CUSTOM_MODULE_ATTAINMENT_BOX.ATTAINMENT_DATA_NOT_FOUND"> Suorituksen tietoja ei löydy </span>
      </span> </div
    ><!--
     --><div class="extra-items-holder">
      <div class="additional-box toggle-box"> <ng-transclude></ng-transclude> </div
      ><!--
         --><div class="grade-box"> <sis-icon icon="achievement"></sis-icon> </div
      ><!--
         --><div class="credits-box">
        <sis-icon icon="alert-fill-attention"></sis-icon>
      </div>
    </div>
  </div>
</div>
`;
export default template;
